import { getGridPin } from './getGridPin';
import { EClusterPinAnchor } from './types';
import { IFeatureProperties } from '../../types/map';

// anchor пина по его слоту сетки с дефолтом Center (для не-кластерных/одиночных пинов).
// Единая точка дефолта — чтобы BalloonManager (рендер) и OfferPreviewContainer (превью)
// не дублировали `getGridPin(...)?.anchor ?? Center`.
export function getPinAnchor(properties: IFeatureProperties, maxPinsPerCluster: number): EClusterPinAnchor {
  return getGridPin(properties.pinsCount, properties.pinIndex, maxPinsPerCluster)?.anchor ?? EClusterPinAnchor.Center;
}
